var _ = require('underscore');
var React = require("react");
const createReactClass = require("create-react-class");

var PlaceholderForm = createReactClass({
	render() {
		return (
			<div className='integration-placeholder'>
				<i className="fa fa-rocket fa-3x"></i>
				<p>Choose an integration to add</p>
			</div>
		);
	}
});

module.exports = PlaceholderForm;
